import { useBoundStore } from '~/src/store';

const useAppointmentId = () => useBoundStore((s) => s.appointmentId);
const useAppointmentUserId = () => useBoundStore((s) => s.userId);
const useAppointmentUserType = () => useBoundStore((s) => s.userType);
const useSetAppointmentSession = () =>
  useBoundStore((s) => s.setAppointmentSession);
const useResetAppointmentSession = () =>
  useBoundStore((s) => s.resetAppointmentSession);

export {
  useAppointmentId,
  useAppointmentUserId,
  useAppointmentUserType,
  useSetAppointmentSession,
  useResetAppointmentSession,
};
